import BIsland from '@/components/b-island'
import BRadio from '@/components/form-elements/b-radio'
import BInput from '@/components/form-elements/b-input'
import BTextarea from '@/components/form-elements/b-textarea'
import BButton from '@/components/form-elements/b-button'
import BDatePicker from '@/components/b-datepicker'
import BUl from '@/components/b-ul'
import BFileUploader from '@/components/b-file-uploader'
import BDialog from '@/components/b-dialog'
import BTable from '@/components/table/b-table'
import BConfirm from '@/components/b-confirm'

export default {
  install(Vue) {
    Vue.component('b-island', BIsland)
    Vue.component('b-radio', BRadio)
    Vue.component('b-input', BInput)
    Vue.component('b-textarea', BTextarea)
    Vue.component('b-datepicker', BDatePicker)
    Vue.component('b-button', BButton)
    Vue.component('b-ul', BUl)
    Vue.component('b-file-uploader', BFileUploader)
    Vue.component('b-dialog', BDialog)
    Vue.component('b-table', BTable)
    Vue.component('b-confirm', BConfirm)
  }
}
